import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

// TODO add color to library
const hoverBg = '#EBF6F7';

export const sxStyles = {
  schoolTitleWrap: {
    width: '56%',
    padding: '1.5rem 0 1.5rem 2rem',
  },
  schoolTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginBottom: '0.5rem',
  }),
  utahBadgeWrap: {
    display: 'flex',
    marginBottom: '0.5rem',
  },
  schoolAddressWrap: {
    display: 'flex',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },
  },
  actionsWrap: {
    display: 'flex',
    alignItems: 'center',
    width: '240px',
    padding: '1.5rem 0',
  },
  favoriteBtn: {
    width: '50%',
    maxHeight: '52px',
    height: '100%',
  },
};

export const StyledLinearSchoolCard = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  marginBottom: '0.5rem',
  background: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderRadius: '0 4px 4px 0',
  borderLeft: `4px solid ${theme.palette.primary.main}`,
}));

export const StyledInfographicContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '300px',
  justifyContent: 'space-between',
  padding: '1.875rem 1rem',
  // TODO add color to library
  background: '#F2F2F2',
}));

export const StyledNotes = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50%',
  minWidth: '50px',
  maxHeight: '52px',
  height: '100%',
  borderRight: `1px solid ${theme.palette.grey['300']}`,

  '& > svg:first-of-type': {
    fill: theme.palette.primary.main,
  },

  ':hover': {
    cursor: 'pointer',
    backgroundColor: hoverBg,
  },
}));

export const StyledMoreLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50%',
  maxHeight: '52px',
  height: '100%',
  color: theme.palette.primary.main,
  borderLeft: `1px solid ${theme.palette.grey['300']}`,

  '& > svg:first-of-type': {
    fill: theme.palette.primary.main,
  },

  ':hover': {
    backgroundColor: hoverBg,
  },
}));

export const StyledDistance = styled(CoreTypography)({
  flexShrink: 0,
  whiteSpace: 'pre',
});
